/*
 * ORA: "Componi il tuo set" (sections/ora-set-builder.liquid).
 * Dati veri dal JSON della sezione: pezzi (ora.set_pieces) con varianti per colore e taglia, set per colore.
 * Tendine con il markup di snippets/ora-size-dropdown.liquid: apertura, tastiera e scelta le gestisce
 * assets/ora-size-dropdown.js; qui si legge la scelta da aria-selected.
 */
(() => {
  if (window.oraSetBuilder) return;
  window.oraSetBuilder = true;

  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)');
  const PLS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4v16M4 12h16"/></svg>';
  const ARW = '<svg class="ora-dd__i" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  /** Viste dal metafield ora.set_views (JSON): { views: [{ image, label, pieces: [{ zones, point, tag } | null] }] } */
  function cfgViews(cfg) {
    if (!cfg || !Array.isArray(cfg.views)) return [];
    return cfg.views.filter((v) => v && v.image).map((v) => {
      const z = {};
      (v.pieces || []).forEach((pc, i) => {
        if (!pc) return;
        const r = (pc.zones || []).filter((q) => Array.isArray(q) && q.length === 4 && q.every((n) => typeof n === 'number'));
        const pt = Array.isArray(pc.point) && pc.point.length >= 2 ? pc.point : null;
        z[i] = { r, a: pt ? [pt[0], pt[1], typeof pc.tag === 'number' ? pc.tag : pt[1]] : null };
      });
      return { k: String(v.image).replace(/\.[a-z]+$/i, ''), label: String(v.label || ''), z };
    });
  }

  /** Righe delle viste (impostazione di riserva): file | etichetta | 1: x y l a, x y l a @ x y ly | 2: ... */
  function parseViews(txt) {
    return String(txt || '')
      .split(/\r?\n/)
      .map((line) => line.split('|').map((x) => x.trim()))
      .filter((c) => c.length >= 2 && c[0])
      .map((c) => {
        const z = {};
        c.slice(2).forEach((seg) => {
          const m = seg.match(/^(\d+)\s*:\s*(.*)$/);
          if (!m) return;
          const [rects, anchor] = m[2].split('@');
          const r = (rects || '').split(',').map((q) => q.trim().split(/\s+/).map(Number)).filter((q) => q.length === 4 && q.every((n) => !isNaN(n)));
          const a = (anchor || '').trim().split(/\s+/).map(Number);
          z[+m[1] - 1] = { r, a: a.length >= 2 && a.every((n) => !isNaN(n)) ? [a[0], a[1], a.length > 2 ? a[2] : a[1]] : null };
        });
        return { k: c[0], label: c[1], z };
      });
  }

  function mask(white, black) {
    const r = (a, c) => a.map((q) => `<rect x="${q[0]}" y="${q[1]}" width="${q[2]}" height="${q[3]}" rx="2" fill="${c}"/>`).join('');
    const s = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none"><defs><filter id="b" x="-5%" y="-5%" width="110%" height="110%"><feGaussianBlur stdDeviation=".7"/></filter><mask id="m" maskUnits="userSpaceOnUse" x="0" y="0" width="100" height="100"><g filter="url(#b)">${r(white, '#fff')}${r(black, '#000')}</g></mask></defs><rect width="100" height="100" fill="#000" mask="url(#m)"/></svg>`;
    return `url("data:image/svg+xml,${encodeURIComponent(s)}")`;
  }

  function init(root) {
    const D = JSON.parse(root.querySelector('[data-ors-data]').textContent);
    const q = (s) => root.querySelector(s);
    const T = D.texts;
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    const fmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency });
    const money = (c) => fmt.format(c / 100);
    const P = D.pieces;
    const N = P.length;
    const uid = 'ors' + D.section.replace(/[^a-z0-9]/gi, '');

    // colori: unione dei colori dei pezzi, nell'ordine del primo pezzo
    const COLS = [];
    const NAMED = { black: '#000000', nero: '#000000', white: '#ffffff', bianco: '#ffffff' };
    P.forEach((p) => p.colors.forEach((c) => {
      const x = COLS.find((y) => y.n === c.n);
      if (!x) COLS.push({ n: c.n, h: c.h });
      else if (!x.h && c.h) x.h = c.h;
    }));
    COLS.forEach((c) => { if (!c.h && c.n) c.h = NAMED[c.n.toLowerCase()] || ''; });
    const hasColors = COLS.length > 0;
    if (!hasColors) COLS.push({ n: null, h: '' });
    const endsWith = (t, c) => c && t.toLowerCase().trim().endsWith(' ' + c.toLowerCase());
    const setFor = {};
    COLS.forEach((c) => {
      const s = D.sets.find((x) => endsWith(x.title, c.n)) || (COLS.length === 1 ? D.sets[0] : null);
      if (s) {
        s.map = s.opts.map((name) => P.findIndex((p) => name.toLowerCase().includes(p.title.toLowerCase())));
        s.ok = s.map.length === N && s.map.every((i) => i > -1) && new Set(s.map).size === N;
      }
      setFor[c.n] = s;
    });
    const cur = D.sets.find((s) => s.id === D.current);
    const curColor = (COLS.find((c) => cur && endsWith(cur.title, c.n)) || COLS[0]).n;
    const baseTitle = (t) => { const c = COLS.find((x) => endsWith(t, x.n)); return c ? t.slice(0, t.length - c.n.length).trim() : t; };

    const VIEWS = parseViews(D.views);
    const slug = (c) => String(c || '').toLowerCase().trim().replace(/\s+/g, '-');
    const h1el = root.querySelector('[data-ors-h1]');
    const barName = h1el ? (h1el.firstChild && h1el.firstChild.nodeType === 3 ? h1el.firstChild.textContent : h1el.textContent).trim() : '';
    const S = { c: curColor, view: null, inc: P.map(() => true), sz: P.map(() => null), mode: 'set' };

    const photos = () => { const s = setFor[S.c] || cur; return (s && s.m) || []; };
    function views() {
      const ph = photos();
      const s = setFor[S.c] || cur;
      const out = [];
      const add = (list) => list.forEach((v) => { const m = ph.find((x) => x.k === v.k); if (m && !out.find((o) => o.label === v.label)) out.push({ label: v.label, u: m.u, t: m.t, z: v.z }); });
      add(cfgViews(s && s.cfg));
      if (!out.length) add(VIEWS);
      if (!out.length) ph.slice(0, 3).forEach((m, i) => out.push({ label: 'Vista ' + (i + 1), u: m.u, t: m.t, z: null }));
      return out;
    }
    const hasMarks = () => views().some((v) => v.z && Object.keys(v.z).some((i) => v.z[i] && v.z[i].a));
    const view = () => { const vs = views(); return vs.find((v) => v.label === S.view) || vs[0]; };

    const vOf = (i, c) => P[i].v.filter((v) => v.c === c || v.c === null);
    const avail = (i) => vOf(i, S.c).some((v) => v.a);
    const on = (i) => S.inc[i] && avail(i);
    const pv = (i) => vOf(i, S.c).find((v) => v.s === S.sz[i]);
    const pprice = (i) => { const v = pv(i); if (v) return v.p; const all = vOf(i, S.c); return all.length ? Math.min(...all.map((x) => x.p)) : 0; };
    const sizes = (i) => { const out = []; vOf(i, S.c).forEach((v) => { if (!out.find((x) => x.s === v.s)) out.push({ s: v.s, a: vOf(i, S.c).some((w) => w.s === v.s && w.a) }); }); return out; };

    function state() {
      const inc = P.map((p, i) => i).filter(on);
      const sum = inc.reduce((a, i) => a + pprice(i), 0);
      const s = setFor[S.c];
      const setAny = !!(s && s.ok && s.v.some((v) => v.a));
      const all = inc.length === N && N > 1 && setAny;
      const allSized = P.every((p, i) => !!S.sz[i]);
      let sv = null;
      if (s && s.ok && allSized) sv = s.v.find((v) => v.o.every((val, j) => val === S.sz[s.map[j]])) || null;
      const setBlocked = all && allSized && (!sv || !sv.a);
      const setPrice = sv ? sv.p : s ? Math.min(...s.v.map((v) => v.p)) : 0;
      const asSet = all && !setBlocked;
      const setCmp = sv ? (sv.cp || 0) : s ? Math.max(0, ...s.v.map((v) => v.cp || 0)) : 0;
      const cmp = asSet && setCmp > setPrice ? setCmp : 0;
      return { inc, n: inc.length, sum, all, sv, setBlocked, setPrice, asSet, price: asSet ? setPrice : sum, cmp, set: s };
    }

    /* ---------- palco ---------- */
    const stage = q('[data-ors-stage]');
    const cos = q('[data-ors-cos]');
    let frame = null;
    cos.innerHTML =
      '<svg class="ors-lk" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">' +
      P.map((p, i) => `<path data-i="${i}" style="d:path('M 50 50 L 50 50 L 100 50')"/>`).join('') +
      '</svg>' +
      P.map((p, i) => `<button type="button" class="ors-zn" data-i="${i}" style="z-index:${2 + i}" aria-label="Taglia ${esc(p.title)}"></button>`).join('') +
      P.map((p, i) => `<div class="ors-co" data-i="${i}"><button type="button" class="ors-hp" data-i="${i}"></button><button type="button" class="ors-tg" data-i="${i}"><span class="ors-tg-n">0${i + 1} ${esc(p.short)}</span><span class="ors-tg-v"></span></button></div>`).join('');
    let wasActive = false, downI = null;
    cos.querySelectorAll('.ors-hp').forEach((b) => {
      // lo stato "attivo" va letto prima che il tocco chiuda la tendina
      b.addEventListener('pointerdown', () => { downI = +b.dataset.i; wasActive = selI === downI && isOpen(downI); });
      b.addEventListener('click', (e) => {
        const i = +b.dataset.i;
        const active = downI === i ? wasActive : selI === i && isOpen(i);
        wasActive = false;
        downI = null;
        if (!avail(i)) return;
        if (on(i) && active) { S.inc[i] = false; selI = null; msg(''); update(); paintHl(); return; }
        select(i, true);
      });
    });
    cos.querySelectorAll('.ors-tg, .ors-zn').forEach((b) => b.addEventListener('click', () => select(+b.dataset.i, true)));
    cos.querySelectorAll('.ors-hp, .ors-tg, .ors-zn').forEach((b) => {
      b.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { hovI = +b.dataset.i; paintHl(); } });
      b.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { hovI = null; paintHl(); } });
    });

    function drawFrame() {
      const v = view();
      if (!v) return;
      S.view = v.label;
      const zr = (i) => (v.z && v.z[i] ? v.z[i].r : []);
      const fr = document.createElement('div');
      fr.className = 'ors-fr';
      fr.style.opacity = '0';
      fr.innerHTML = `<img src="${esc(v.u)}" alt="${esc(baseTitle(cur ? cur.title : '') + ' ' + (S.c || '') + ', ' + v.label)}">` + P.map((p, i) => `<div class="ors-gh" data-i="${i}"></div>`).join('');
      fr.querySelectorAll('.ors-gh').forEach((g) => {
        const i = +g.dataset.i;
        const others = [];
        for (let k = i + 1; k < N; k++) others.push(...zr(k));
        const m = mask(zr(i), others);
        g.style.webkitMaskImage = m;
        g.style.maskImage = m;
      });
      stage.insertBefore(fr, stage.querySelector('.ors-top'));
      const old = frame;
      frame = fr;
      ghosts();
      requestAnimationFrame(() => requestAnimationFrame(() => { fr.style.opacity = '1'; }));
      if (old) setTimeout(() => old.remove(), 560);
      // bottoni vista
      const vb = q('[data-ors-views]');
      const vs = views();
      vb.hidden = vs.length < 2;
      vb.innerHTML = vs.map((x) => `<button type="button" aria-pressed="${x.label === S.view}">${esc(x.label)}</button>`).join('');
      vb.querySelectorAll('button').forEach((b, k) => b.addEventListener('click', () => { if (vs[k].label !== S.view) { S.view = vs[k].label; drawFrame(); update(); } }));
      if (typeof marksUi === 'function') marksUi();
    }
    function ghosts() { if (frame) P.forEach((p, i) => frame.querySelector(`.ors-gh[data-i="${i}"]`).classList.toggle('is-on', !on(i))); }

    /* ---------- colori ---------- */
    const colsBox = q('[data-ors-cols]');
    if (!hasColors) colsBox.closest('.ors-step').hidden = true;
    /** Nota sotto il colore: pezzi esauriti in tutte le taglie in quel colore. */
    function colorNote(c) {
      const out = P.filter((p, i) => !vOf(i, c).some((v) => v.a)).map((p) => p.short.toLowerCase());
      if (!out.length) return N > 1 ? 'Tutti i pezzi disponibili' : 'Disponibile';
      if (out.length === N) return 'Esaurito';
      const txt = out.length === 1 ? out[0] : out.slice(0, -1).join(', ') + ' e ' + out[out.length - 1];
      return txt.charAt(0).toUpperCase() + txt.slice(1) + (out.length === 1 ? ' esaurito' : ' esauriti');
    }
    function renderColors() {
      colsBox.innerHTML = COLS.map((c) => {
        const note = colorNote(c.n);
        return `<button type="button" class="ors-cc" data-c="${esc(c.n)}" aria-pressed="${c.n === S.c}"><i style="background:${esc(c.h || '#fff')}"></i><span><b>${esc(c.n)}</b><small>${esc(note)}</small></span></button>`;
      }).join('');
      colsBox.querySelectorAll('.ors-cc').forEach((b) => b.addEventListener('click', () => {
        if (b.dataset.c === S.c) return;
        S.c = b.dataset.c;
        colsBox.querySelectorAll('.ors-cc').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        // le taglie restano se esistono nel nuovo colore
        P.forEach((p, i) => { if (S.sz[i] && !sizes(i).find((x) => x.s === S.sz[i] && x.a)) S.sz[i] = null; });
        renderDropdowns();
        thumbs();
        drawFrame();
        update();
        specPhoto();
        Gira.color();
        Fit.render();
      }));
    }

    /* ---------- pezzi ---------- */
    const pzs = q('[data-ors-pzs]');
    pzs.innerHTML = P.map((p, i) => `<div class="ors-pz" data-i="${i}"><button type="button" class="ors-tk" role="checkbox" aria-checked="true" aria-label="Includi ${esc(p.title)}"><span class="ors-ck"></span></button><div class="ors-th"><img alt="" loading="lazy"><span class="ors-pzn" aria-hidden="true">0${i + 1}</span></div><div class="ors-pzi"></div><div class="ors-dd-slot"></div></div>`).join('');
    pzs.querySelectorAll('.ors-tk').forEach((b) => b.addEventListener('click', () => toggle(+b.closest('.ors-pz').dataset.i)));
    pzs.querySelectorAll('.ors-pz').forEach((row) => {
      const i = +row.dataset.i;
      row.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { hovI = i; paintHl(); } });
      row.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { hovI = null; paintHl(); } });
      row.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) { focI = i; paintHl(); } });
      row.addEventListener('focusout', (e) => { if (!row.contains(e.relatedTarget)) { focI = null; paintHl(); } });
    });

    /* ---------- collegamento foto e righe ---------- */
    // selI: pezzo attivo, finché la sua tendina è aperta; hovI: mouse; focI: tastiera
    let selI = null, hovI = null, focI = null;
    const isOpen = (i) => !!pzs.querySelector(`.ors-pz[data-i="${i}"] .ora-dd.ora-dd--open`);
    function paintHl() {
      const k = hovI != null ? hovI : focI != null ? focI : selI;
      P.forEach((p, i) => {
        pzs.querySelector(`.ors-pz[data-i="${i}"]`).classList.toggle('is-hl', i === k);
        cos.querySelector(`.ors-co[data-i="${i}"]`).classList.toggle('is-hl', i === k);
      });
    }
    // quando la tendina del pezzo attivo si chiude, il pezzo torna normale (niente stati appesi dopo un tocco)
    new MutationObserver(() => {
      if (selI != null && !isOpen(selI) && !pending) { selI = null; paintHl(); }
    }).observe(pzs, { subtree: true, attributes: true, attributeFilter: ['class'] });
    let pending = false;
    /** Porta la riga del pezzo in vista (se serve) e apre la sua tendina. */
    function openRow(i, forceScroll) {
      const row = pzs.querySelector(`.ors-pz[data-i="${i}"]`);
      const r = row.getBoundingClientRect();
      const bar = q('[data-ors-bar]');
      const barH = bar && bar.classList.contains('is-on') ? bar.getBoundingClientRect().height : 0;
      const hidden = r.top < 90 || r.bottom > innerHeight - barH - 16;
      if (forceScroll || hidden) row.scrollIntoView({ behavior: REDUCED.matches ? 'auto' : 'smooth', block: 'center' });
      pending = true;
      setTimeout(() => {
        const dd = row.querySelector('.ora-dd');
        const btn = row.querySelector('.ora-dd__btn');
        if (btn && !btn.disabled && !dd.classList.contains('ora-dd--open')) btn.click();
        pending = false;
        if (selI === i && !isOpen(i)) { selI = null; paintHl(); }
      }, forceScroll || hidden ? 550 : 0);
    }
    function select(i, open) {
      if (!avail(i)) return;
      if (!S.inc[i]) { S.inc[i] = true; msg(''); update(); }
      selI = open ? i : null;
      paintHl();
      if (open) openRow(i, false);
    }

    function ddHTML(id, label, aria, opts, sel, ph) {
      return `<div class="ora-dd" data-ora-dd data-ors-dd="${id}"><button type="button" class="ora-dd__btn" aria-haspopup="listbox" aria-expanded="false" aria-controls="${id}" aria-label="${esc(aria)}: ${esc(sel || ph)}"><span class="ora-dd__l">${esc(label)}</span><span class="ora-dd__v${sel ? '' : ' is-ph'}">${esc(sel || ph)}</span>${ARW}</button><ul class="ora-dd__list" role="listbox" id="${id}" tabindex="-1" aria-label="${esc(aria)}">${opts
        .map((o, k) => `<li role="option" id="${id}-${k}" data-value-id="${id}-${k}" data-v="${esc(o.v)}" aria-selected="${o.v === sel}"${o.a ? '' : ' aria-disabled="true"'}>${o.a ? `<span>${esc(o.l)}</span>` : `<s>${esc(o.l)}</s><em>Esaurita</em>`}</li>`)
        .join('')}</ul></div>`;
    }
    function renderDropdowns() {
      P.forEach((p, i) => {
        const slot = pzs.querySelector(`.ors-pz[data-i="${i}"] .ors-dd-slot`);
        slot.innerHTML = ddHTML(`${uid}-p${i}-${(S.c || 'x').replace(/\W/g, '')}`, 'Taglia', 'Taglia ' + p.title, sizes(i).map((x) => ({ v: x.s, l: x.s, a: x.a })), S.sz[i], 'Scegli');
        slot.firstChild.dataset.piece = String(i);
      });
    }
    function thumbs() {
      const vs = views();
      const v0 = vs.find((v) => v.z) || vs[0];
      P.forEach((p, i) => {
        const im = pzs.querySelector(`.ors-pz[data-i="${i}"] .ors-th img`);
        if (!v0) return;
        im.src = v0.t || v0.u;
        const r = v0.z && v0.z[i] && v0.z[i].r.length ? v0.z[i].r : null;
        if (!r) {
          // senza zone: la prima foto del pezzo con il colore nel nome del file, altrimenti la foto del set
          const sl = slug(S.c), alt = sl.replace('pynk', 'pink');
          const own = sl && (p.m || []).find((m) => m.k.includes('-' + sl + '-') || m.k.includes('-' + alt + '-') || m.k.endsWith('-' + sl) || m.k.endsWith('-' + alt));
          if (own) im.src = own.t || own.u;
          im.className = 'is-full';
          im.removeAttribute('style');
          return;
        }
        const x0 = Math.min(...r.map((q) => q[0])), y0 = Math.min(...r.map((q) => q[1]));
        const x1 = Math.max(...r.map((q) => q[0] + q[2])), y1 = Math.max(...r.map((q) => q[1] + q[3]));
        const h = Math.min(100, Math.max(y1 - y0, ((x1 - x0) * 4) / 3) * 1.08);
        const z = 100 / h;
        im.className = '';
        im.style.width = 100 * z + '%';
        im.style.left = 50 - ((x0 + x1) / 2) * z + '%';
        im.style.top = 50 - ((y0 + y1) / 2) * z + '%';
      });
    }

    // scelta dalle tendine: la gestisce ora-size-dropdown.js, qui si legge aria-selected
    new MutationObserver((list) => {
      let changed = false;
      list.forEach((m) => {
        const li = m.target;
        if (!(li instanceof HTMLElement) || li.getAttribute('aria-selected') !== 'true') return;
        const dd = li.closest('[data-ors-dd]');
        if (!dd) return;
        if (dd.dataset.piece != null) {
          const i = +dd.dataset.piece;
          if (S.sz[i] !== li.dataset.v) { S.sz[i] = li.dataset.v; changed = true; }
          dd.classList.remove('is-miss');
          dd.querySelector('.ora-dd__v')?.classList.remove('is-ph');
        }
      });
      if (changed) { msg(''); update(); Fit.table(); }
    }).observe(root, { subtree: true, attributes: true, attributeFilter: ['aria-selected'] });

    function toggle(i) {
      if (!avail(i)) return;
      S.inc[i] = !S.inc[i];
      msg('');
      update();
    }

    /* ---------- prezzo che scorre ---------- */
    const ron = q('[data-ors-ron]');
    let shown = null, raf = 0;
    function roll(to) {
      cancelAnimationFrame(raf);
      if (shown === null || REDUCED.matches) { shown = to; ron.textContent = money(to); return; }
      const from = shown, t0 = performance.now();
      const st = (t) => {
        const k = Math.min(1, (t - t0) / 420), e = 1 - Math.pow(1 - k, 3);
        shown = from + (to - from) * e;
        ron.textContent = money(Math.round(shown));
        if (k < 1) raf = requestAnimationFrame(st); else { shown = to; ron.textContent = money(to); }
      };
      raf = requestAnimationFrame(st);
    }

    const msgEl = q('[data-ors-msg]');
    const msg = (t) => { msgEl.textContent = t; };
    const outTxt = T.out;
    const soTxt = () => (T.soldOut.trim() + ' ' + (S.c || '')).trim();

    function update() {
      const st = state();
      const v = view();
      ghosts();
      P.forEach((p, i) => {
        const co = cos.querySelector(`.ors-co[data-i="${i}"]`);
        const pa = cos.querySelector(`path[data-i="${i}"]`);
        const a = v && v.z && v.z[i] ? v.z[i].a : null;
        const o = on(i), ok = avail(i);
        co.classList.toggle('is-hide', !a);
        pa.classList.toggle('is-hide', !a);
        pa.classList.toggle('is-off', !o);
        if (a) {
          co.style.setProperty('--x', a[0] + '%');
          co.style.setProperty('--y', a[1] + '%');
          co.style.setProperty('--ly', a[2] + '%');
          pa.style.d = `path('M ${a[0]} ${a[1]} L ${a[0] + (a[2] === a[1] ? 0 : 7)} ${a[2]} L 100 ${a[2]}')`;
        }
        co.classList.toggle('is-off', !o);
        co.classList.toggle('is-so', !ok);
        const zn = cos.querySelector(`.ors-zn[data-i="${i}"]`);
        const zr = v && v.z && v.z[i] ? v.z[i].r : [];
        zn.hidden = !zr.length || !ok;
        if (zr.length) {
          const q0 = zr[0];
          Object.assign(zn.style, { left: q0[0] + '%', top: q0[1] + '%', width: q0[2] + '%', height: q0[3] + '%' });
        }
        const hp = co.querySelector('.ors-hp');
        hp.innerHTML = o ? `0${i + 1}` : PLS;
        hp.disabled = !ok;
        hp.setAttribute('aria-label', !ok ? `${p.title}: ${soTxt()}` : o ? `${p.title}: scegli la taglia; tocca di nuovo per toglierlo` : `Rimetti ${p.title}`);
        co.querySelector('.ors-tg-v').innerHTML = !ok ? esc(soTxt()) : o ? esc(S.sz[i] ? 'Taglia ' + S.sz[i] : T.chooseSize) + `<span class="ors-pr"> · ${esc(money(pprice(i)))}</span>` : esc(outTxt);

        const row = pzs.querySelector(`.ors-pz[data-i="${i}"]`);
        row.classList.toggle('is-off', !o);
        const tk = row.querySelector('.ors-tk');
        tk.setAttribute('aria-checked', String(o));
        tk.disabled = !ok;
        row.querySelector('.ors-pzi').innerHTML = `<a href="${esc(p.url)}">${esc(p.title)}</a><span class="ors-num">${ok ? esc(money(pprice(i))) : `<em>${esc(soTxt())}</em>`}</span>`;
        const btn = row.querySelector('.ora-dd__btn');
        const val = row.querySelector('.ora-dd__v');
        if (!o || S.sz[i]) row.querySelector('.ora-dd')?.classList.remove('is-miss');
        if (btn) {
          btn.disabled = !o;
          if (!o) { val.textContent = ok ? '' : 'Esaurito'; val.classList.add('is-ph'); }
          else { val.textContent = S.sz[i] || 'Scegli'; val.classList.toggle('is-ph', !S.sz[i]); }
          btn.setAttribute('aria-label', `Taglia ${p.title}: ${o ? S.sz[i] || 'nessuna scelta' : val.textContent}`);
        }
      });
      q('[data-ors-pzv]').textContent = `${st.n} di ${N}`;
      q('[data-ors-cv]').textContent = S.c || '';
      q('[data-ors-stc]').textContent = [S.c, v && v.label].filter(Boolean).join(' · ');
      q('[data-ors-stn]').textContent = `${st.n} di ${N} pezzi`;
      roll(st.price);
      q('[data-ors-ros]').textContent = !st.n ? T.noneChosen : `${st.n === 1 ? '1 pezzo' : st.n + ' pezzi'}${S.c ? ', ' + S.c : ''}`;
      q('[data-ors-sumn]').textContent = st.n === 1 ? '1 pezzo' : `${st.n} pezzi`;
      q('[data-ors-suml]').innerHTML = st.n
        ? st.inc.map((i) => `<li><span>${esc(P[i].title)}${S.c ? ' ' + esc(S.c) : ''}</span><span>${esc(S.sz[i] ? 'Taglia ' + S.sz[i] : T.chooseSize)}</span><span class="ors-num">${esc(money(pprice(i)))}</span></li>`).join('')
        : `<li class="is-none">${esc(T.noneChosen)}.</li>`;
      q('[data-ors-tot]').textContent = money(st.price);
      [['[data-ors-cmp]'], ['[data-ors-totc]'], ['[data-ors-barc]']].forEach(([sel]) => { const el = q(sel); if (el) { el.hidden = !st.cmp; el.textContent = st.cmp ? money(st.cmp) : ''; } });
      { const of = q('[data-ors-offer]'); if (of) of.hidden = !st.cmp; }
      const atc = q('[data-ors-atc]');
      atc.disabled = !st.n || busy;
      q('[data-ors-atct]').textContent = st.n ? T.add : T.noneChosen;
      // barra fissa
      const ph0 = views()[0];
      const im = q('[data-ors-barim]');
      if (ph0 && im.dataset.src !== (ph0.t || ph0.u)) { im.dataset.src = ph0.t || ph0.u; im.src = ph0.t || ph0.u; }
      q('[data-ors-bart]').textContent = [barName, S.c].filter(Boolean).join(' · ');
      q('[data-ors-barn]').textContent = st.n ? money(st.price) : '';
      q('[data-ors-barp]').innerHTML = st.inc.map((i) => `<button type="button" data-i="${i}" class="${S.sz[i] ? '' : 'is-miss'}">${esc(P[i].short)} <b>${esc(S.sz[i] || T.choose)}</b></button>`).join('<span aria-hidden="true">·</span>') || `<span>${esc(T.noneChosen)}</span>`;
      q('[data-ors-barb]').disabled = !st.n || busy;
    }

    /* ---------- carrello ---------- */
    let busy = false;
    async function add(fromBar) {
      const st = state();
      if (!st.n || busy) return;
      const miss = st.inc.filter((i) => !S.sz[i]);
      if (miss.length) {
        msg(`Scegli la taglia di: ${miss.map((i) => P[i].short).join(', ')}`);
        miss.forEach((i) => pzs.querySelector(`.ors-pz[data-i="${i}"] .ora-dd`)?.classList.add('is-miss'));
        if (fromBar) {
          selI = miss[0];
          paintHl();
          q('[data-ors-steppz]').scrollIntoView({ behavior: REDUCED.matches ? 'auto' : 'smooth', block: 'start' });
          setTimeout(() => openRow(miss[0], false), 600);
        } else {
          const first = pzs.querySelector(`.ors-pz[data-i="${miss[0]}"]`);
          first.scrollIntoView({ behavior: REDUCED.matches ? 'auto' : 'smooth', block: 'center' });
          first.querySelector('.ora-dd__btn')?.focus({ preventScroll: true });
        }
        return;
      }
      let items;
      if (st.asSet) {
        if (!st.sv || !st.sv.a) { msg('Questa combinazione non è disponibile come set.'); return; }
        items = [{ id: st.sv.id, quantity: 1 }];
      } else {
        const vs = st.inc.map((i) => pv(i));
        const bad = st.inc.filter((i, k) => !vs[k] || !vs[k].a);
        if (bad.length) { msg(`Taglia esaurita per: ${bad.map((i) => P[i].short.toLowerCase()).join(', ')}.`); return; }
        items = vs.map((v) => ({ id: v.id, quantity: 1 }));
      }
      busy = true;
      update();
      const label = q('[data-ors-atct]');
      label.textContent = 'Aggiunta in corso';
      const ids = Array.from(document.querySelectorAll('cart-items-component')).map((e) => e.dataset.sectionId).filter(Boolean);
      const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      try {
        const res = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: ids.join(',') }) }).then((r) => r.json());
        if (res.status) { msg(res.description || res.message || 'Non disponibile'); return; }
        const cart = await fetch(base + 'cart.js').then((r) => r.json());
        msg(T.added);
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ora-set', data: { source: 'ora-set', itemCount: cart.item_count, sections: res.sections } } }));
        setTimeout(() => { if (msgEl.textContent === T.added) msg(''); }, 2500);
      } catch (e) {
        msg('Riprova tra poco');
      } finally {
        busy = false;
        update();
      }
    }
    q('[data-ors-atc]').addEventListener('click', () => add(false));
    q('[data-ors-barb]').addEventListener('click', () => add(true));
    q('[data-ors-barp]').addEventListener('click', (e) => {
      const b = e.target.closest('button[data-i]');
      if (!b) return;
      const i = +b.dataset.i;
      selI = i;
      paintHl();
      openRow(i, true);
    });

    /* ---------- barra fissa da telefono ---------- */
    const bar = q('[data-ors-bar]');
    const showBar = (o) => {
      bar.classList.toggle('is-on', o);
      bar.setAttribute('aria-hidden', String(!o));
      bar.inert = !o;
      document.documentElement.classList.toggle('ors-has-bar', o);
    };
    if ('IntersectionObserver' in window) new IntersectionObserver((e) => showBar(!e[0].isIntersecting)).observe(q('[data-ors-atc]'));

    /* ---------- titoli senza il colore ---------- */
    const h1 = q('[data-ors-h1] span');
    if (h1) h1.textContent = baseTitle(h1.textContent);
    else { const h = q('[data-ors-h1]'); h.textContent = baseTitle(h.textContent); }
    const crumb = q('[data-ors-crumb]');
    if (crumb) crumb.textContent = baseTitle(crumb.textContent);
    const same = q('[data-ors-same]');
    if (same) {
      const names = P.map((p) => p.short.toLowerCase());
      same.textContent = 'Uguale per ' + (names.length > 1 ? names.slice(0, -1).join(', ') + ' e ' + names[names.length - 1] : names[0]);
    }

    /* ---------- mostra o nascondi i pezzi sulla foto ---------- */
    const tgl = q('[data-ors-tgl]');
    const KEY = 'ora-set-pezzi';
    let pzShown = null;
    try { const v = sessionStorage.getItem(KEY); if (v === '1' || v === '0') pzShown = v === '1'; } catch (e) {}
    if (pzShown === null) pzShown = !matchMedia('(max-width: 749px)').matches;
    function setShown(v, save) {
      pzShown = v;
      stage.classList.toggle('is-clean', !v);
      if (tgl) {
        tgl.setAttribute('aria-pressed', String(!v));
        tgl.setAttribute('aria-label', v ? 'Nascondi pezzi sulla foto' : 'Mostra pezzi sulla foto');
        q('[data-ors-tglt]').textContent = v ? 'Nascondi pezzi' : 'Mostra pezzi';
      }
      if (save) { try { sessionStorage.setItem(KEY, v ? '1' : '0'); } catch (e) {} }
    }
    if (tgl) tgl.addEventListener('click', () => setShown(!pzShown, true));
    setShown(pzShown, false);
    function marksUi() {
      const m = hasMarks();
      stage.classList.toggle('is-nomarks', !m);
      if (tgl) tgl.hidden = !m;
      const h = q('[data-ors-hint]');
      if (h) h.hidden = !m;
    }

    /* ---------- descrizione su una riga e Leggi tutto ---------- */
    const sdt = q('[data-ors-sdt]');
    const sdb = q('[data-ors-sdb]');
    function fitLine() {
      if (!sdt) return;
      const full = sdt.dataset.full;
      sdt.textContent = full;
      if (sdt.scrollWidth <= sdt.clientWidth + 1) return;
      const words = full.replace(/…$/, '').split(' ');
      for (let n = words.length - 1; n > 0; n--) {
        const t = words.slice(0, n).join(' ').replace(/[,:;.]$/, '') + '…';
        sdt.textContent = t;
        if (sdt.scrollWidth <= sdt.clientWidth + 1) return;
      }
    }
    if (sdb) sdb.addEventListener('click', () => {
      const more = q('.ors-sd-more');
      const o = sdb.getAttribute('aria-expanded') !== 'true';
      sdb.setAttribute('aria-expanded', String(o));
      sdb.textContent = o ? 'Chiudi' : 'Leggi tutto';
      more.hidden = !o;
      fitLine();
    });
    fitLine();
    let lineT = 0;
    window.addEventListener('resize', () => { clearTimeout(lineT); lineT = setTimeout(fitLine, 120); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitLine);

    /* ---------- foto della scheda tecnica nel colore scelto ---------- */
    function specPhoto() {
      const fig = q('[data-ors-specim]');
      const im = fig && fig.querySelector('img');
      const ph = photos();
      const m = ph[1] || ph[0];
      if (!im || !m || im.dataset.k === m.k) return;
      im.dataset.k = m.k;
      im.removeAttribute('srcset');
      im.src = m.u;
    }

    /* ---------- zona sinistra ferma se più alta dello spazio sotto l'header ---------- */
    const lcol = q('[data-ors-l]');
    function stickyCheck() {
      if (!lcol) return;
      lcol.classList.remove('is-static');
      if (innerWidth < 1280) return;
      const top = parseFloat(getComputedStyle(lcol).top) || 88;
      lcol.classList.toggle('is-static', lcol.offsetHeight > innerHeight - top - 16);
    }

    /* ---------- Gira il set: fotogrammi da ora.set_views (spin) ---------- */
    const Gira = (() => {
      const sec = q('[data-ors-gira]');
      const none = { color() {} };
      if (!sec) return none;
      const v = sec.querySelector('[data-grv]'), tabs = sec.querySelector('[data-grt]'), strip = sec.querySelector('[data-grstrip]'), track = sec.querySelector('[data-grtrack]'), dial = sec.querySelector('[data-dial]');
      let tab = null, i = 0, F = [], spin = 0, used = false, G = [];
      let tk = '';
      for (let a = 0; a < 360; a += 15) {
        const big = a % 90 === 0, r1 = big ? 38 : 42, rad = (a * Math.PI) / 180;
        tk += `<line x1="${(64 + r1 * Math.sin(rad)).toFixed(2)}" y1="${(64 - r1 * Math.cos(rad)).toFixed(2)}" x2="${(64 + 48 * Math.sin(rad)).toFixed(2)}" y2="${(64 - 48 * Math.cos(rad)).toFixed(2)}"/>`;
      }
      dial.innerHTML = `<circle cx="64" cy="64" r="48"/><g class="tk">${tk}</g><text x="64" y="9">FRONTE</text><text x="64" y="126">RETRO</text><line class="nd" x1="64" y1="64" x2="64" y2="30"/><rect x="60" y="60" width="8" height="8" fill="#000"/>`;
      const nd = dial.querySelector('.nd');
      const pool = () => {
        const s = setFor[S.c] || cur;
        const all = [].concat((s && s.m) || []);
        P.forEach((p) => (p.m || []).forEach((m) => all.push(m)));
        return all;
      };
      /** Gruppi del colore scelto con almeno 3 fotogrammi trovati tra le foto vere. */
      function groups() {
        const s = setFor[S.c] || cur;
        const cfg = s && s.cfg;
        if (!cfg || !Array.isArray(cfg.spin)) return [];
        const ph = pool();
        return cfg.spin.map((g) => {
          const fr = (g.frames || []).map((f) => {
            const m = ph.find((x) => x.k === String(f.image || '').replace(/\.[a-z]+$/i, ''));
            return m ? { u: m.u, t: m.t, n: String(f.label || ''), g: +f.angle || 0 } : null;
          }).filter(Boolean);
          return { name: String(g.name || ''), F: fr };
        }).filter((g) => g.name && g.F.length >= 3);
      }
      function build() {
        G = groups();
        sec.hidden = !G.length;
        if (!G.length) return;
        if (!G.find((g) => g.name === tab)) tab = G[0].name;
        tabs.hidden = G.length < 2;
        tabs.innerHTML = G.map((g) => `<button type="button" role="tab" data-k="${esc(g.name)}" aria-selected="${g.name === tab}">${esc(g.name)}<span>${g.F.length}</span></button>`).join('');
        F = G.find((g) => g.name === tab).F;
        v.querySelectorAll('img').forEach((x) => x.remove());
        F.forEach((fr, k) => { const im = new Image(); im.src = fr.u; im.alt = ''; im.draggable = false; im.dataset.k = k; v.insertBefore(im, v.firstChild); });
        strip.style.setProperty('--n', F.length);
        strip.innerHTML = F.map((fr, k) => `<figure data-k="${k}"><div class="im"><img src="${esc(fr.t || fr.u)}" alt="" draggable="false" loading="lazy"></div><figcaption>${esc(fr.n)}</figcaption></figure>`).join('');
        show(0);
      }
      function show(k) {
        if (!F.length) return;
        i = ((k % F.length) + F.length) % F.length;
        v.querySelectorAll('img').forEach((m) => m.classList.toggle('is-on', +m.dataset.k === i));
        strip.querySelectorAll('figure').forEach((f) => f.classList.toggle('is-on', +f.dataset.k === i));
        track.querySelector('b').style.left = ((i + 0.5) / F.length) * 100 + '%';
        nd.style.transform = `rotate(${F[i].g}deg)`;
        sec.querySelector('[data-gran]').textContent = F[i].n;
        sec.querySelector('[data-gras]').textContent = `${i + 1} di ${F.length}`;
        v.setAttribute('aria-label', `${tab}${S.c ? ' ' + S.c : ''}, ${F[i].n.toLowerCase()}. Trascina o usa le frecce per girare`);
      }
      function use() { used = true; v.classList.add('is-used'); clearInterval(spin); }
      tabs.addEventListener('click', (e) => { const b = e.target.closest('button[data-k]'); if (!b) return; use(); tab = b.dataset.k; build(); });
      let x0 = 0, i0 = 0, drag = false;
      v.addEventListener('pointerdown', (e) => { if (!F.length) return; drag = true; x0 = e.clientX; i0 = i; use(); v.classList.add('is-drag'); try { v.setPointerCapture(e.pointerId); } catch (er) {} });
      v.addEventListener('pointermove', (e) => {
        if (!drag) return;
        const step = v.clientWidth / (F.length + 1);
        const d = Math.round((x0 - e.clientX) / step);
        const n = (((i0 + d) % F.length) + F.length) % F.length;
        if (n !== i) show(n);
      });
      const up = () => { drag = false; v.classList.remove('is-drag'); };
      v.addEventListener('pointerup', up);
      v.addEventListener('pointercancel', up);
      v.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); use(); show(i + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); use(); show(i - 1); }
      });
      const scrub = (el) => {
        let dr = false;
        const at = (e) => { const r = el.getBoundingClientRect(); const pp = Math.max(0, Math.min(0.999, (e.clientX - r.left) / r.width)); const k = Math.floor(pp * F.length); if (k !== i) show(k); };
        el.addEventListener('pointerdown', (e) => { if (!F.length) return; dr = true; use(); try { el.setPointerCapture(e.pointerId); } catch (er) {} at(e); });
        el.addEventListener('pointermove', (e) => { if (dr) at(e); });
        el.addEventListener('pointerup', () => { dr = false; });
        el.addEventListener('pointercancel', () => { dr = false; });
      };
      scrub(strip);
      scrub(track);
      // giro di presentazione, una volta sola quando la foto entra in vista
      if ('IntersectionObserver' in window && !REDUCED.matches) {
        const io = new IntersectionObserver((en) => {
          if (!en[0].isIntersecting) return;
          io.disconnect();
          if (used) return;
          let k = 0;
          spin = setInterval(() => { k++; if (used || k >= F.length) { clearInterval(spin); if (!used) show(0); return; } show(k); }, 520);
        }, { threshold: 0.6 });
        io.observe(v);
      }
      build();
      return { color: () => { clearInterval(spin); build(); } };
    })();

    /* ---------- Tu e la modella e Misure in centimetri: solo con dati veri ---------- */
    const Fit = (() => {
      const secM = q('[data-ors-model]'), secC = q('[data-ors-sizes]'), wrap = q('[data-ors-fm]');
      const SIZES = [];
      P.forEach((p) => p.v.forEach((v) => { if (v.s && !SIZES.includes(v.s)) SIZES.push(v.s); }));
      const mi = String(D.modelInfo || '');
      const mh = mi.match(/(\d{3})\s*cm/i), ms = mi.match(/taglia\s+([A-Za-z0-9]+)/i);
      const MODEL = mh && ms ? { h: +mh[1], s: ms[1].toUpperCase() } : null;
      // tabella: prima riga Misura | S | M | L, poi Seno | 80 84 | ...
      const rows = String(D.sizeChart || '').split(/\r?\n/).map((l) => l.split('|').map((x) => x.trim())).filter((c) => c.length >= 2 && c[0]);
      const head = rows.length > 1 ? rows[0].slice(1) : [];
      const body = rows.length > 1 ? rows.slice(1) : [];
      const cell = (t) => { const n = String(t || '').match(/\d+(?:[.,]\d+)?/g); if (!n) return String(t || ''); return n.length >= 2 ? `da ${n[0]} a ${n[1]}` : n[0]; };
      const lnk = q('[data-ors-lnk]');
      const lm = q('[data-ors-lnkm]'), lc = q('[data-ors-lnkc]'), ls = q('[data-ors-lnks]');
      if (secM) secM.hidden = !MODEL;
      if (secC) secC.hidden = !(head.length && body.length);
      if (lm) lm.hidden = !MODEL;
      if (lc) lc.hidden = !(head.length && body.length);
      if (ls) ls.hidden = !MODEL || !(head.length && body.length);
      if (lnk) lnk.hidden = !MODEL && !(head.length && body.length);
      if (wrap) wrap.hidden = (!secM || secM.hidden) && (!secC || secC.hidden);
      const me = { h: 165, s: null };
      let applied = null, last = null;
      const mt = secC && !secC.hidden ? secC.querySelector('[data-mt]') : null;
      if (mt) mt.innerHTML = `<thead><tr><th scope="col">${esc(rows[0][0] || 'Misura')}</th>${head.map((h) => `<th scope="col" data-col="${esc(h)}">${esc(h)}</th>`).join('')}</tr></thead><tbody>${body.map((r) => `<tr><th scope="row">${esc(r[0])}</th>${head.map((h, k) => `<td data-col="${esc(h)}">${esc(cell(r[k + 1]))}</td>`).join('')}</tr>`).join('')}</tbody>`;
      function table() {
        if (!mt) return;
        const chosen = S.sz.find(Boolean);
        const s = me.s || last || chosen || null;
        mt.querySelectorAll('[data-col]').forEach((c) => c.classList.toggle('is-sel', c.dataset.col === s));
      }
      if (!MODEL || !secM) { table(); return { render: table, table }; }
      const $m = (x) => secM.querySelector(x);
      const MAX = 210;
      const chp = $m('[data-chp]');
      [50, 100, 150, 200].forEach((cm) => {
        const g = document.createElement('i'); g.className = 'ors-chg'; g.style.bottom = (cm / MAX) * 100 + '%'; chp.prepend(g);
        const a = document.createElement('span'); a.className = 'ors-cha'; a.textContent = cm; a.style.bottom = (cm / MAX) * 100 + '%'; chp.prepend(a);
      });
      $m('[data-ors-msub]').textContent = `La modella è alta ${MODEL.h} cm e indossa la taglia ${MODEL.s}.`;
      $m('[data-mdbar]').style.height = (MODEL.h / MAX) * 100 + '%';
      $m('[data-mdval]').textContent = MODEL.h + ' cm';
      const seg = $m('[data-myseg]');
      seg.innerHTML = SIZES.map((x) => `<button type="button" aria-pressed="false" data-s="${esc(x)}">${esc(x)}</button>`).join('');
      const scl = $m('[data-scl]');
      if (scl) {
        const st = String(D.sizeType || '').toLowerCase();
        const pos = /strett|slim|picc/.test(st) ? 0 : /ampi|comod|larg|over|grand/.test(st) ? 100 : /regol/.test(st) ? 50 : null;
        if (pos == null) scl.parentElement.hidden = true;
        else { scl.querySelector('i').style.left = pos + '%'; scl.setAttribute('aria-label', 'Vestibilità ' + st); }
      }
      const inp = $m('[data-hin]');
      const longP = P.find((p) => p.long);
      const adv = String(D.sizeAdvice || '').split(',')[0].trim();
      function render() {
        $m('[data-mebar]').style.height = (me.h / MAX) * 100 + '%';
        $m('[data-meval]').textContent = me.h + ' cm';
        if (document.activeElement !== inp) inp.value = me.h;
        const diff = me.h - MODEL.h;
        $m('[data-r1]').textContent = diff === 0 ? 'Sei alta come la modella.' : `Sei alta ${me.h} cm, ${Math.abs(diff)} cm ${diff < 0 ? 'meno' : 'più'} della modella.`;
        $m('[data-r2]').textContent = me.s ? `${adv ? adv + ': ti' : 'Ti'} consigliamo la tua taglia abituale, la ${me.s}.` : 'Scegli la taglia che porti di solito per il consiglio.';
        const nm = longP ? longP.short.toLowerCase() : '';
        const pl = nm === 'leggings' || nm === 'pantaloni';
        $m('[data-r3]').textContent = longP && Math.abs(diff) >= 6 ? `${nm.charAt(0).toUpperCase() + nm.slice(1)} ti ${pl ? 'arriveranno' : 'arriverà'} un po' più ${diff < 0 ? (pl ? 'lunghi' : 'lungo') : (pl ? 'corti' : 'corto')} alla caviglia.` : '';
        const b = $m('[data-r4]');
        b.hidden = !me.s;
        if (me.s) b.textContent = applied === me.s + S.c ? `Taglia ${me.s} scelta` : N > 1 ? `Usa la ${me.s} per tutti i pezzi` : `Scegli la ${me.s}`;
        if (applied !== me.s + S.c) $m('[data-r5]').textContent = '';
        seg.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', String(x.dataset.s === me.s)));
        table();
      }
      const setH = (h) => { me.h = Math.max(140, Math.min(200, Math.round(h))); applied = null; render(); };
      $m('[data-hm]').addEventListener('click', () => setH(me.h - 1));
      $m('[data-hp]').addEventListener('click', () => setH(me.h + 1));
      inp.addEventListener('input', () => { const h = +inp.value; if (h >= 140 && h <= 200) { me.h = h; render(); } });
      inp.addEventListener('change', () => { setH(+inp.value || 165); inp.value = me.h; });
      inp.addEventListener('blur', () => { inp.value = me.h; });
      seg.addEventListener('click', (e) => { const b = e.target.closest('button[data-s]'); if (!b) return; me.s = b.dataset.s; applied = null; render(); });
      $m('[data-r4]').addEventListener('click', () => {
        if (!me.s) return;
        const no = [];
        P.forEach((p, i) => {
          if (!on(i)) return;
          if (sizes(i).find((x) => x.s === me.s && x.a)) S.sz[i] = me.s;
          else no.push(p.short.toLowerCase());
        });
        last = me.s;
        applied = me.s + S.c;
        renderDropdowns();
        update();
        render();
        $m('[data-r5]').textContent = no.map((n) => `La ${me.s} ${n === 'giacca' ? 'della' : n === 'leggings' ? 'dei' : 'del'} ${n} non è disponibile${S.c ? ' in ' + S.c : ''}.`).join(' ');
      });
      render();
      return { render, table };
    })();

    renderColors();
    renderDropdowns();
    thumbs();
    drawFrame();
    update();
    specPhoto();
    stickyCheck();
    let stT = 0;
    window.addEventListener('resize', () => { clearTimeout(stT); stT = setTimeout(stickyCheck, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(stickyCheck);
    if (window.OraPref && window.OraPref.aggiorna) window.OraPref.aggiorna();
  }

  const start = () => document.querySelectorAll('[data-ora-set]').forEach((r) => { if (!r.dataset.orsReady) { r.dataset.orsReady = '1'; try { init(r); } catch (e) { console.error('ORA set', e); } } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
